import React, { useState } from 'react';
import { InputCheck, InputCheckNo, InputCheckNone, InputCheckYes, InputSingleCheck, NuFormInputNew, NuFormInputNumberNew, NuFormSelect, NuFormTextArea, NuInputfile, NuRowFormInput, NuTableFormInput, NuTableFormSelect } from '../../../../Components/Utils/Input';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { BackButton } from '../../../../Components/Utils/Buttons';

function CreateForms({ formik }) {
  const [formName, setFormName] = useState('');
  const [headings, setHeadings] = useState([]);
  const [currentHeading, setCurrentHeading] = useState('');
  const [newTitle, setNewTitle] = useState('');
  const [newHeading, setNewHeading] = useState('');
  const [questionType, setQuestionType] = useState('text');
  const [allValue, setAllValue] = useState({}); 
  const [editModeIndex, ] = useState(false); 

  const questionTypes = [
    'text',
    'number',
    'string',
    'yesno',
    'checkbox',
    'single_checkbox',
    'textArea',
    'observation',
    'date',
    'time',
    'imagePath',
    'file',
    'table-data',
    'multi',
    'tableRow',
    'tableItems',
    'yesnona',
    'heading',
    'tableHeaders',
  ];

  const suggestedHeadings = [
    'Fire Extinguisher',
    'Fire Pump',
    'Suppression System',
    'Sprinkler System',
    'Alarm System',
    'Hose Reel',
  ];

  const defaultOptions = [
    { label: 'Option 1', value: 'option1' },
    { label: 'Option 2', value: 'option2' },
    { label: 'Option 3', value: 'option3' },
  ];

  const addHeading = () => {
    if (!newHeading || headings.some((h) => h.headingName === newHeading)) return;
    const updatedHeadings = [...headings, { headingName: newHeading, titles: [] }];
    setHeadings(updatedHeadings);
    setCurrentHeading(newHeading); 
    setNewHeading('');
  };

  const addTitle = () => {
    if (!newTitle || !currentHeading) return;
    const updatedHeadings = headings.map((heading) => {
      if (heading.headingName === currentHeading) {
        const newField = {
          title: newTitle,
          type: questionType,
          field_label: newTitle,
          id: `${currentHeading}-${Date.now()}`,
          field_type: questionType,
          value: `${newTitle.toLowerCase().replace(/\s+/g, '_')}`,
          metadata:
            questionType === 'checkbox' ||
            questionType === 'single_checkbox' ||
            questionType === 'multi' ||
            questionType === 'tableRow' ||
            questionType === 'tableHeaders'
              ? { option1: questionType === 'multi' ? 'text' : questionType }
              : questionType === 'tableItems'
              ? [{ option1: 'text' }]
              : questionType === 'yesno' || questionType === 'yesnona'
              ? ['Yes', 'No', 'N/A']
              : [],
        };
        return {
          ...heading,
          titles: [...heading.titles, newField],
        };
      }
      return heading;
    });
    setHeadings(updatedHeadings);
    setNewTitle('');
  };

  const handleFormNameChange = (e) => {
    setFormName(e.target.value.toUpperCase());
  };

  const renderInputField = (value) => {
    switch (value.field_type) {
      case 'text':
        return (
          <div className="w-full py-2 text-xs">
            <table className="w-full">
              <tr>
                <td className="w-3/5">
                  <p>{value.field_label || ''}</p>
                </td>
                <td className="w-2/5">
                  <NuFormInputNew
                    label=""
                    type="text"
                    formik={formik}
                    placeholder={value.title}
                    name={value.value}
                    width="w-full"
                    id={value.id}
                    field_type={value?.field_type}
                    allValue={allValue}
                    setAllValue={setAllValue}
                    disabled={!editModeIndex}
                  />
                </td>
              </tr>
            </table>
          </div>
        );
      case 'number':
        return (
          <div className="w-full py-2 text-xs">
            <table className="w-full">
              <tr>
                <td className="w-3/5">
                  <p>{value.field_label || ''}</p>
                </td>
                <td className="w-2/5">
                  <NuFormInputNumberNew
                    label=""
                    formik={formik}
                    placeholder={value.title}
                    name={value.value}
                    width="w-full"
                    id={value.id}
                    field_type={value.field_type}
                    allValue={allValue}
                    setAllValue={setAllValue}
                    disabled={!editModeIndex}
                  />
                </td>
              </tr>
            </table>
          </div>
        );
      case 'string':
        return (
          <div className="w-full py-2 text-xs mt-5">
            <table className="w-full">
              <tr>
                <td className="w-full">
                  <p>{value.title}</p>
                </td>
              </tr>
            </table>
          </div>
        );
      case 'yesno':
      case 'yesnona':
        return (
          <div className="w-full py-2 text-xs mt-5">
            <table className="w-full">
              <tr>
                <td className="w-3/5">
                  <p>{value.field_label}</p>
                </td>
                {['Yes', 'No', 'N/A'].map((option, index) => (
                  <td key={index} className="px-2">
                    <div className="flex justify-center items-center gap-1.5">
                      <p>{option}</p>
                      {option === 'Yes' ? (
                        <InputCheckYes
                          type="checkbox"
                          formik={formik}
                          placeholder=""
                          name={value.field_label}
                          id={`${value.id}-${option}`}
                          field_type={value.field_type}
                          allValue={allValue}
                          setAllValue={setAllValue}
                          disabled={!editModeIndex}
                          label={value.field_label}
                        />
                      ) : option === 'No' ? (
                        <InputCheckNo
                          type="checkbox"
                          formik={formik}
                          placeholder=""
                          name={value.field_label}
                          id={`${value.id}-${option}`}
                          field_type={value.field_type}
                          allValue={allValue}
                          setAllValue={setAllValue}
                          disabled={!editModeIndex}
                          label={value.field_label}
                        />
                      ) : (
                        <InputCheckNone
                          type="checkbox"
                          formik={formik}
                          placeholder=""
                          name={value.field_label}
                          id={`${value.id}-${option}`}
                          field_type={value.field_type}
                          allValue={allValue}
                          setAllValue={setAllValue}
                          disabled={!editModeIndex}
                          label={value.field_label}
                        />
                      )}
                    </div>
                  </td>
                ))}
              </tr>
            </table>
          </div>
        );
      case 'checkbox':
        return (
          <div className="w-full py-2 text-xs mt-5">
            <table className="w-full">
              <tbody>
                <tr>
                  <td className="w-2/12 align-top">
                    <p>{value.field_label}</p>
                  </td>
                  <td className="w-10/12 p-0">
                    <table className="w-full">
                      <tbody>
                        {Array.from({
                          length: Math.ceil(Object.entries(value.metadata || {}).length / 5),
                        }).map((_, rowIndex) => {
                          const items = Object.entries(value.metadata || {}).slice(
                            rowIndex * 5,
                            rowIndex * 5 + 5
                          );
                          const emptyCells = 5 - items.length;
                          return (
                            <tr key={rowIndex}>
                              {items.map(([key, valueOf], idx) => (
                                <td key={idx} className="w-1/6 p-2">
                                  <div className="flex flex-row-reverse justify-start items-center gap-2">
                                    <InputCheck
                                      fullValue={value.value}
                                      label={key}
                                      formik={formik}
                                      placeholder=""
                                      name={key}
                                      id={`${value.id}-${key}`}
                                      field_type={value.field_type}
                                      allValue={allValue}
                                      setAllValue={setAllValue}
                                      disabled={!editModeIndex}
                                    />
                                    <p>{key}</p>
                                  </div>
                                </td>
                              ))}
                              {Array.from({ length: emptyCells }).map((_, i) => (
                                <td key={`empty-${i}`} className="w-1/6 p-2"></td>
                              ))}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      case 'single_checkbox':
        return (
          <div className="w-full py-2 text-xs mt-5">
            <table className="w-full">
              <tr>
                <td className="w-2/12">
                  <p>{value.field_label}</p>
                </td>
                {Object.entries(value.metadata || {}).map(([key, valueOf], idx) => (
                  <td key={idx} className="w-1/12 p-2">
                    <div className="flex flex-row-reverse justify-start items-center gap-2">
                      <InputSingleCheck
                        fullValue={value.value}
                        label={key}
                        formik={formik}
                        placeholder=""
                        name={key}
                        id={`${value.id}-${key}`}
                        field_type={value.field_type}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={!editModeIndex}
                      />
                      <p>{key}</p>
                    </div>
                  </td>
                ))}
              </tr>
            </table>
          </div>
        );
      case 'textArea':
      case 'observation':
        return (
          <NuFormTextArea
            label=""
            placeholder={value.field_label || ''}
            formik={formik}
            name={value.field_label}
            new_width="w-full"
            id={value.id}
            field_type={value.field_type}
            allValue={allValue}
            setAllValue={setAllValue}
            disabled={!editModeIndex}
          />
        );
      case 'date':
        return (
          <div className="w-full py-2 text-xs">
            <table className="w-full">
              <tr>
                <td className="w-3/5">
                  <p>{value.field_label}</p>
                </td>
                <td className="w-2/5">
                  <NuFormInputNew
                    label=""
                    type="date"
                    formik={formik}
                    placeholder={value.title}
                    name={value.value}
                    width="w-full"
                    id={value.id}
                    field_type={value.field_type}
                    allValue={allValue}
                    setAllValue={setAllValue}
                    disabled={!editModeIndex}
                  />
                </td>
              </tr>
            </table>
          </div>
        );
      case 'time':
        return (
          <div className="w-full py-2 text-xs">
            <table className="w-full">
              <tr>
                <td className="w-3/5">
                  <p>{value.title}</p>
                </td>
                <td className="w-2/5">
                  <NuFormInputNew
                    label=""
                    type="time"
                    formik={formik}
                    placeholder={value.title}
                    name={value.value}
                    width="w-full"
                    id={value.id}
                    field_type={value.field_type}
                    allValue={allValue}
                    setAllValue={setAllValue}
                    disabled={!editModeIndex}
                  />
                </td>
              </tr>
            </table>
          </div>
        );
      case 'imagePath':
      case 'file':
        return (
          <NuInputfile
            label=""
            name={value.field_label}
            handleChange={() => {}}
            width="w-full"
            placeholder="File upload"
          />
        );
      case 'table-data':
        return (
          <div className="w-full">
            <table className="w-full text-xs">
              <thead>
                <tr>
                  {(value.metadata || []).map((item, k) => (
                    <th key={k} className="text-left py-2 px-4">
                      {item.label || ''}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array(10)
                  .fill(0)
                  .map((_, i) => (
                    <tr key={i}>
                      {(value.metadata || []).map((item, k) => (
                        <td key={k} className="text-left py-2 px-4 h-8 border">
                          {''}
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        );
      case 'multi':
        return (
          <div className="w-full">
            {Object.keys(value.metadata || {}).length > 3 ? (
              <div className="grid grid-cols-4 gap-2 items-center text-xs">
                <div>{value.field_label || ''}</div>
                {Object.entries(value.metadata || {}).map(([key, valueOf], i) => (
                  <div
                    key={i}
                    className={`w-full flex gap-3 items-center ${
                      (i + 1) % 5 !== 1 ? 'text-end' : 'text-start'
                    } ${i + 1 === 1 ? 'text-end' : ''} ${
                      (i + 1) % 4 === 0 && i + 1 !== 1 ? 'col-span-2' : ''
                    }`}
                  >
                    {key === 'Comments' ? (
                      <div className="col-span-3 grid grid-cols-3">
                        <div></div>
                        <div className="col-span-2 flex items-center justify-end">
                          <p className="">{key}</p>
                          <NuFormTextArea
                            placeholder=""
                            formik={formik}
                            name={valueOf.value}
                            new_width="w-5/6"
                            id={value.id}
                            field_type={value.field_type}
                            allValue={allValue}
                            setAllValue={setAllValue}
                            disabled={!editModeIndex}
                            label={key}
                          />
                        </div>
                      </div>
                    ) : valueOf === 'text' ? (
                      <>
                        <p className="w-1/3 text-xs text-right">{key}</p>
                        <NuFormInputNew
                          label={key}
                          type="text"
                          formik={formik}
                          placeholder={valueOf.Name || key}
                          name={valueOf.value || key}
                          id={value.id}
                          field_type={value.field_type}
                          allValue={allValue}
                          setAllValue={setAllValue}
                          width="w-2/3"
                          disabled={!editModeIndex}
                        />
                      </>
                    ) : valueOf === 'number' ? (
                      <>
                        <p className="w-1/3 text-xs text-right">{key}</p>
                        <NuFormInputNumberNew
                          label={key}
                          formik={formik}
                          placeholder={valueOf.Name || key}
                          name={valueOf.value || key}
                          id={value.id}
                          field_type={value.field_type}
                          allValue={allValue}
                          setAllValue={setAllValue}
                          width="w-2/3"
                          disabled={!editModeIndex}
                        />
                      </>
                    ) : valueOf === 'yesno' || valueOf === 'yesnona' ? (
                      <div className="w-full py-2 text-xs">
                        <table className="w-full">
                          <tr>
                            <td className="w-3/5 text-end px-2">
                              <p>{key}</p>
                            </td>
                            {['Yes', 'No', 'N/A'].map((option, idx) => (
                              <td key={idx} className="px-2">
                                <div className="flex justify-center items-center gap-1.5">
                                  <p>{option}</p>
                                  {option === 'Yes' ? (
                                    <InputCheckYes
                                      type="checkbox"
                                      formik={formik}
                                      placeholder=""
                                      name={key}
                                      id={`${value.id}-${key}-${option}`}
                                      field_type={value.field_type}
                                      allValue={allValue}
                                      setAllValue={setAllValue}
                                      disabled={!editModeIndex}
                                      label={key}
                                    />
                                  ) : option === 'No' ? (
                                    <InputCheckNo
                                      type="checkbox"
                                      formik={formik}
                                      placeholder=""
                                      name={key}
                                      id={`${value.id}-${key}-${option}`}
                                      field_type={value.field_type}
                                      allValue={allValue}
                                      setAllValue={setAllValue}
                                      disabled={!editModeIndex}
                                      label={key}
                                    />
                                  ) : (
                                    <InputCheckNone
                                      type="checkbox"
                                      formik={formik}
                                      placeholder=""
                                      name={key}
                                      id={`${value.id}-${key}-${option}`}
                                      field_type={value.field_type}
                                      allValue={allValue}
                                      setAllValue={setAllValue}
                                      disabled={!editModeIndex}
                                      label={key}
                                    />
                                  )}
                                </div>
                              </td>
                            ))}
                          </tr>
                        </table>
                      </div>
                    ) : valueOf === 'dropdown' ? (
                      <div className="w-full py-2 text-xs">
                        <table className="w-full">
                          <tr>
                            <td className="w-5/12 text-end px-2">
                              <p>{key}</p>
                            </td>
                            <td className="px-2">
                              <NuFormSelect
                                name={key}
                                label={key}
                                placeholder=""
                                id={value.id}
                                field_type={value.field_type}
                                allValue={allValue}
                                setAllValue={setAllValue}
                                disabled={!editModeIndex}
                                options={defaultOptions}
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                    ) : (
                      <p className="w-full text-xs">{key}</p>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <table className="w-full">
                <tr>
                  {Object.entries(value.metadata || {}).map(([key, valueOf], idx) => (
                    <td key={idx} className="text-xs text-end first:text-start">
                      {valueOf === 'text' ? (
                        <div className="w-full flex gap-3 items-center">
                          <p className="w-1/2 text-xs">{key}</p>
                          <NuFormInputNew
                            label={key}
                            type="text"
                            formik={formik}
                            placeholder={valueOf.Name || key}
                            name={valueOf.value || key}
                            id={value.id}
                            field_type={value.field_type}
                            allValue={allValue}
                            setAllValue={setAllValue}
                            width="w-1/2"
                            disabled={!editModeIndex}
                          />
                        </div>
                      ) : valueOf === 'number' ? (
                        <div className="w-full flex gap-3 items-center">
                          <p className="w-1/2 text-xs">{key}</p>
                          <NuFormInputNumberNew
                            label={key}
                            formik={formik}
                            placeholder={valueOf.Name || key}
                            name={valueOf.value || key}
                            id={value.id}
                            field_type={value.field_type}
                            allValue={allValue}
                            setAllValue={setAllValue}
                            width="w-1/2"
                            disabled={!editModeIndex}
                          />
                        </div>
                      ) : valueOf === 'yesno' || valueOf === 'yesnona' ? (
                        <div className="w-full py-2 text-xs">
                          <table className="w-full">
                            <tr>
                              <td className="w-3/5 text-end px-2">
                                <p>{key}</p>
                              </td>
                              {['Yes', 'No', 'N/A'].map((option, idx) => (
                                <td key={idx} className="px-2">
                                  <div className="flex justify-center items-center gap-1.5">
                                    <p>{option}</p>
                                    {option === 'Yes' ? (
                                      <InputCheckYes
                                        type="checkbox"
                                        formik={formik}
                                        placeholder=""
                                        name={key}
                                        id={`${value.id}-${key}-${option}`}
                                        field_type={value.field_type}
                                        allValue={allValue}
                                        setAllValue={setAllValue}
                                        disabled={!editModeIndex}
                                        label={key}
                                      />
                                    ) : option === 'No' ? (
                                      <InputCheckNo
                                        type="checkbox"
                                        formik={formik}
                                        placeholder=""
                                        name={key}
                                        id={`${value.id}-${key}-${option}`}
                                        field_type={value.field_type}
                                        allValue={allValue}
                                        setAllValue={setAllValue}
                                        disabled={!editModeIndex}
                                        label={key}
                                      />
                                    ) : (
                                      <InputCheckNone
                                        type="checkbox"
                                        formik={formik}
                                        placeholder=""
                                        name={key}
                                        id={`${value.id}-${key}-${option}`}
                                        field_type={value.field_type}
                                        allValue={allValue}
                                        setAllValue={setAllValue}
                                        disabled={!editModeIndex}
                                        label={key}
                                      />
                                    )}
                                  </div>
                                </td>
                              ))}
                            </tr>
                          </table>
                        </div>
                      ) : (
                        <p>{key}</p>
                      )}
                    </td>
                  ))}
                </tr>
              </table>
            )}
          </div>
        );
      case 'tableRow':
        return (
          <table className="w-full border border-collapse">
            <tr>
              {Object.entries(value.metadata || {}).map(([key, valueOf], idx) => (
                <td
                  key={idx}
                  className={`${
                    Object.keys(value.metadata || {}).length >= 3 ? '' : ''
                  }text-xs border-y px-3`}
                >
                  {valueOf === 'text' ? (
                    <NuRowFormInput
                      label={key}
                      type="text"
                      formik={formik}
                      placeholder={valueOf.Name || key}
                      name={valueOf.value || key}
                      id={value.id}
                      field_type={value.field_type}
                      allValue={allValue}
                      setAllValue={setAllValue}
                      width="w-full"
                      disabled={!editModeIndex}
                    />
                  ) : valueOf === 'date' ? (
                    <NuRowFormInput
                      label={key}
                      type="date"
                      formik={formik}
                      placeholder={valueOf.Name || key}
                      name={valueOf.value || key}
                      id={value.id}
                      field_type={value.field_type}
                      allValue={allValue}
                      setAllValue={setAllValue}
                      width="w-full"
                      disabled={!editModeIndex}
                    />
                  ) : (
                    <p className="w-full">{key}</p>
                  )}
                </td>
              ))}
            </tr>
          </table>
        );
      case 'tableItems':
        return (
          <table className="w-full border border-collapse text-xs">
            {Array.isArray(value.metadata) && value.metadata.length > 0 ? (
              value.metadata.map((item, idx) => (
                <tr key={idx} className="text-xs">
                  {Object.entries(item).map(([key, valueOf], i) => (
                    <td key={i} className="border py-1 px-2">
                      {valueOf === 'text' ? (
                        <NuTableFormInput
                          label={key}
                          type="text"
                          formik={formik}
                          placeholder={value.title}
                          name={`${key}${valueOf}${idx}`}
                          width="w-full"
                          id={value.id}
                          field_type={value.field_type}
                          allValue={allValue}
                          setAllValue={setAllValue}
                          disabled={!editModeIndex}
                          idx={idx + 1}
                        />
                      ) : valueOf === 'number' ? (
                        <NuTableFormInput
                          label={key}
                          type="number"
                          formik={formik}
                          placeholder={value.title}
                          name={`${key}${valueOf}${idx}`}
                          width="w-full"
                          id={value.id}
                          field_type={value.field_type}
                          allValue={allValue}
                          setAllValue={setAllValue}
                          disabled={!editModeIndex}
                          idx={idx + 1}
                        />
                      ) : valueOf === 'legends' ? (
                        <NuTableFormSelect
                          label={key}
                          formik={formik}
                          placeholder={value.title}
                          name={`${key}${valueOf}${idx}`}
                          width="w-full"
                          id={value.id}
                          field_type={value.field_type}
                          allValue={allValue}
                          setAllValue={setAllValue}
                          disabled={!editModeIndex}
                          idx={idx + 1}
                          options={[
                            { label: 'c', value: 'C' },
                            { label: 't', value: 't' },
                            { label: 'o', value: 'o' },
                            { label: 'N', value: 'N' },
                          ]}
                        />
                      ) : (
                        <p>{key}</p>
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <td>
                <p>No Data</p>
              </td>
            )}
          </table>
        );
      case 'heading':
        return (
          <div className="w-full py-2 text-xs mt-5">
            <table className="w-full">
              <tr>
                <td className="w-full">
                  <p>{value.field_label}</p>
                </td>
              </tr>
            </table>
          </div>
        );
      case 'tableHeaders':
        return (
          <table className="w-full border border-collapse">
            <thead>
              <tr>
                {Object.entries(value.metadata || {}).map(([key, valueOf], idx) => (
                  <th
                    key={idx}
                    className={`min-w-[150px] max-w-[250px] py-2 text-xs border ${
                      Object.entries(value.metadata || {}).length > 10
                        ? '[writing-mode:vertical-lr] max-h-[150px] rotate-180 p-2'
                        : ''
                    }`}
                  >
                    {key}
                  </th>
                ))}
              </tr>
            </thead>
          </table>
        );
      default:
        return <p>No field type specified</p>;
    }
  };

  return (
    <div className="flex flex-col h-[calc(100vh-80px)] p-4 bg-gray-100 overflow-hidden">
     
      <div className="flex justify-between items-center mb-4">
        <Breadcrumb
          items={[
            { name: 'Forms', link: '/forms' },
          ]}
        />
        <BackButton />
      </div>

      <div className="flex flex-1 gap-4 min-h-[calc(100vh-160px)]">
    
        <div className="md:w-[40%] lg:w-[30%] bg-white rounded-lg p-6 shadow-lg flex flex-col gap-4 overflow-y-scroll">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Form Name</label>
            <input
              type="text"
              value={formName}
              onChange={handleFormNameChange}
              className="w-full p-2 border rounded-md bg-gray-50 text-gray-700 focus:outline-none focus:ring-1 focus:ring-baseColor-primary uppercase"
              placeholder="Enter form name"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Select Heading</label>
            <select
              value={currentHeading}
              onChange={(e) => setCurrentHeading(e.target.value)}
              className="w-full p-2 border rounded-md bg-gray-50 text-gray-700 focus:outline-none focus:ring-1 focus:ring-baseColor-primary"
              disabled={headings.length === 0}
            >
              {headings.length === 0 ? (
                <option value="">No headings available</option>
              ) : (
                headings.map((heading, index) => (
                  <option key={index} value={heading.headingName}>
                    {heading.headingName}
                  </option>
                ))
              )}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Add Heading</label>
            <input
              type="text"
              value={newHeading}
              onChange={(e) => setNewHeading(e.target.value)}
              className="w-full p-2 border rounded-md bg-gray-50 text-gray-700 focus:outline-none focus:ring-1 focus:ring-baseColor-primary"
              placeholder="Enter new heading"
              list="suggested-headings"
            />
            <datalist id="suggested-headings">
              {suggestedHeadings.map((suggestion, index) => (
                <option key={index} value={suggestion} />
              ))}
            </datalist>
            <button
              onClick={addHeading}
              className="mt-2 bg-baseColor-primary text-white text-sm font-medium py-2 px-4 rounded-md hover:bg-baseColor-primary transition"
              disabled={!newHeading}
            >
              + Add Heading
            </button>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Enter Question</label>
            <input
              type="text"
              value={newTitle}
              onChange={(e) => setNewTitle(e.target.value)}
              className="w-full p-2 border rounded-md bg-gray-50 text-gray-700 focus:outline-none focus:ring-1 focus:ring-baseColor-primary"
              placeholder="Enter question"
              disabled={!currentHeading}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Question Type</label>
            <select
              value={questionType}
              onChange={(e) => setQuestionType(e.target.value)}
              className="w-full p-2 border rounded-md bg-gray-50 text-gray-700 focus:outline-none focus:ring-1 focus:ring-baseColor-primary"
              disabled={!currentHeading}
            >
              {questionTypes.map((type, index) => (
                <option key={index} value={type}>
                  {type.replace(/([A-Z])/g, ' $1').trim()}
                </option>
              ))}
            </select>
          </div>

          <button
            onClick={addTitle}
            className="bg-baseColor-primary text-white text-sm font-medium py-2 px-4 rounded-md hover:bg-baseColor-primary transition"
            disabled={!newTitle || !currentHeading}
          >
            + Add Question
          </button>

          <div className="flex justify-between mt-4">
            <button className="text-sm font-medium text-gray-600 py-2 px-4 rounded-md hover:bg-gray-100 transition">
              Cancel
            </button>
            <button className="bg-baseColor-primary text-white text-sm font-medium py-2 px-4 rounded-md hover:bg-baseColor-primary transition">
              Save
            </button>
          </div>
        </div>

        <div className="md:w-[60%] lg:w-[70%] bg-white rounded-lg p-6 shadow-lg overflow-y-auto">
          {formName ? (
            <h1 className="text-2xl font-bold text-baseColor-primary mb-6">{formName}</h1>
          ) : (
            <p className="text-gray-500 italic">Please enter a form name.</p>
          )}
          {headings.length === 0 ? (
            <p className="text-gray-500 italic">No headings added yet.</p>
          ) : (
            headings
              .filter((heading) => heading.headingName === currentHeading)
              .map((heading, index) => (
                <div key={index} className="mb-6">
                  <h2 className="text-lg font-semibold text-gray-800 mb-3">{heading.headingName}</h2>
                  {heading.titles.length === 0 ? (
                    <p className="text-gray-500 italic">No questions added yet.</p>
                  ) : (
                    heading.titles.map((title, idx) => (
                      <div key={idx} className="mb-4">
                        {renderInputField(title)}
                      </div>
                    ))
                  )}
                </div>
              ))
          )}
        </div>
      </div>
    </div>
  );
}

export default CreateForms;